import React, { useCallback } from "react";
import { useFocusEffect } from "expo-router";

import withSessionHandling, {
  SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import { useSession } from "@/context/auth/useSession";
import ExploreFeedScreen from "@/screens/Explore/ExploreFeed/ExploreFeedScreen";

function Page(props: SessionHandlerProps): React.JSX.Element {
  const { refreshUserIdentity } = useSession();

  useFocusEffect(
    useCallback(() => {
      refreshUserIdentity();
    }, []), // TODO: adding refreshUserIdentity to the dependencies would keep refreshing the identity
  );

  return <ExploreFeedScreen {...props} isDevTab={true} />;
}

export default withSessionHandling(Page);
